/**
 * 表单校验
 */
const regExp = {
    phone: /^1\d{10}$/
};
class Validate {
    // 获取验证正则
    static getValidate(key) {
        return key ? regExp[key] : null;
    }
    //手机号码验证
    static validatePhone(rule, value, callback) {
        if (!(Validate.getValidate('phone').test(value))) {
            callback(new Error('手机号码有误，请重填'));
        } else {
            callback();
        }
    }
    //邮箱验证
    static validateEmail(rule, value, callback) {
        if (!(/^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/.test(value))) {
            callback(new Error('邮件输入不正确，请重填'));
        } else {
            callback();
        }
    }
    //网址验证
    static validateUrl(value) {
        return /^((http|ftp|https):\/\/)?[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/.test(value);
    }
    //获取网址根域名
    static getDomain(value) {
        let urlReg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;
        let url = urlReg.exec(value);
        return url[0];
    }
}

export default Validate;



// WEBPACK FOOTER //
// ./app/store/validate.js